module.exports = __webpack_public_path__ + "static/media/gM4.3acfa1d7.jpg";